<template>
  <button
    ref="actionButton"
    type="button"
    class="v3-icon-button lh-normal"
    :class="{ active, smaller, middle }"
    :disabled="disabled"
    :tabindex="tabindexAttr"
    :aria-label="ariaLabel || undefined"
    :aria-expanded="ariaExpandedAttr"
    :aria-pressed="ariaPressedAttr"
    :title="tooltip || undefined"
    @click="onClick"
  >
    <i :class="icon" aria-hidden="true"></i>
    <span v-if="text">{{ text }}</span>
  </button>
</template>

<script>
import { computed, ref } from "vue"

export default {
  props: {
    icon: String,
    text: String,
    active: Boolean,
    smaller: Boolean,
    middle: Boolean,
    disabled: Boolean,
    ariaLabel: String,
    tooltip: String,
    /** 'true' | 'false' when toggle exposes expanded state (e.g. filter panel) */
    ariaExpanded: {
      type: [Boolean, String],
      default: undefined
    },
    /** 'true' | 'false' for toggle buttons (e.g. column search) */
    ariaPressed: {
      type: [Boolean, String],
      default: undefined
    },
    /** Omit or use -1 to remove from tab order (e.g. visually hidden controls). */
    tabindex: {
      type: [String, Number],
      default: undefined
    }
  },
  emits: ["click"],
  setup(props, { emit }) {
    const actionButton = ref(null)

    const tabindexAttr = computed(() =>
      props.tabindex === undefined || props.tabindex === null
        ? undefined
        : props.tabindex
    )

    const toAriaBool = (v) => {
      if (v === undefined || v === null) return undefined
      if (v === true || v === "true") return "true"
      if (v === false || v === "false") return "false"
      return undefined
    }

    const ariaExpandedAttr = computed(() => toAriaBool(props.ariaExpanded))
    const ariaPressedAttr = computed(() => toAriaBool(props.ariaPressed))

    const onClick = (event) => {
      actionButton.value?.focus?.()
      emit("click", event)
    }

    return {
      actionButton,
      onClick,
      ariaExpandedAttr,
      ariaPressedAttr,
      tabindexAttr
    }
  }
}
</script>
